
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 3c1.259 0 2.152.89 2.594 2H25v9h2v16H13v-2H5V5h7.406c.442-1.11 1.335-2 2.594-2zm0 2c-.555 0-1 .445-1 1v1h-3v2h8V7h-3V6c0-.555-.445-1-1-1zM7 7v19h6V14h10V7h-2v4H9V7H7zm8 9v12h10V16H15z"}})])
          )
        }
      }
    